module.exports = __webpack_public_path__ + "static/media/statsIco4.1e3e13b3.svg";